import clsx from "clsx";
import { NavItemConfig } from "../types/Navigation.types";

export type NavItemProps = {
    label: string;
    active?: boolean;
    item?: NavItemConfig;
    onNavigate?: (item: NavItemConfig) => void;
};

export const NavItem = ({
    label,
    active = false,
    item,
    onNavigate,
}: NavItemProps) => {
    const handleClick = () => {
        if (item && onNavigate) {
            onNavigate(item);
        }
    };

    return (
        <div
            className={clsx(
                "w-full cursor-pointer select-none rounded-md px-3 py-2",
                "body-s text-left",
                active
                    ? "text-default bg-slate-700"
                    : "subdued hover:bg-slate-700 hover:text-slate-200",

                "transition-colors duration-150 ease-in-out",
            )}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick();
                }
            }}
        >
            {label}
        </div>
    );
};

export default NavItem;
